module.exports = __webpack_public_path__ + "static/media/green_circle.2331fb33.png";